import React from "react"
import StandardTable from "./components/StandardTable"
import { reactWidgetWrapper } from "live/widgets/decorators/react"
import widgetService from "live/services/widgets"
import { reducer } from "./components/dataReducer"
import { type } from "./utils/constants"

const StandatdTableWidget = (
  props: LiveReactChartProps<ChartStateTable, ChartMessageTable, Configs>
): JSX.Element => {
  const value = props.state?.value
  return value && (value.id || value.values) ? (
    <StandardTable
      values={value ? (value.values !== undefined ? value.values : " ") : " "}
      height={props.height}
    />
  ) : null
}

widgetService.register({
  get type() {
    return type
  },
  get name() {
    return "OG Standard Table"
  },
  get description() {
    return "A table with standard styles."
  },
  config: {},
  policies: {
    defaultReducer: "@latest",
  },

  impl: reactWidgetWrapper<ChartStateTable, ChartMessageTable, Configs>(
    StandatdTableWidget,
    reducer
  ),
})
